module.exports = __webpack_public_path__ + "static/media/gym7.b7004a51.png";